import React from "react";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import DataTable from "../../DataTable/DataTable";
import FoliosSelect from "../../Selects/FoliosSelect";
import Tabs from '../../Tabs/Tabs'
import numeral from "numeral";

class FolioBuilderWorkspace extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      transactions_active_tab: "current_charges",
    }
    this.formatCurrency = this.formatCurrency.bind(this)
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  }

  render() {
    var self = this;

    if (this.props.folio_id && this.props.summary) {
      var folio = {
        id: this.props.folio_id,
        name: this.props.summary.folio_name,
      }
    }


    return(
      <div>
        {this.props.edit ? <LoadingSpinner show={this.props.summary ? false : true} /> : null}
        {
          this.props.summary
          ?
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">
                {I18n.t("folio")}

              </h3>

            </div>
            <div className="panel-body container">

              {self.props.edit
                ?
                <div className="row">

                  <div className="col-sm-4 form-group">
                    <label>{I18n.t('description')}</label>
                    {
                        self.props.read_only || self.props.ota_folio
                      ?
                      <div>{self.props.name}</div>
                      :
                      <div>
                        <input name="name" value={this.props.name ? this.props.name : ""} onChange={self.props.onChange} className="form-control" />
                      </div>
                    }
                  </div>

          

                </div>
                :
                <div className="row">
                  <div className="col-md-3">
                    <FoliosSelect reservation_segment_id={this.props.reservation_segment.id} folio={folio} onChange={self.props.onChangeFolio} />
                    <div className="pull-right" style={{marginTop: 7, marginRight: -7}}>
                      <a href={`/admin/folios/new.${this.props.reservation_segment.id}`} data-fullscreen="true" data-nested="true" className="btn btn-link btn-xs modal-iframe">{I18n.t('new_folio')}</a>
                    </div>
                  </div>
                </div>
              }
              <br />

              <div className="panel panel-default">
                <div className="panel-body">
                  <h3 className="panel-heading-text">{I18n.t("summary")}</h3>
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-bordered">
                          {this.renderSummaryTableHead()}
                          {this.renderSummaryTableBody()}
                        </table>

                      </div>
                    </div>
                </div>
              </div>


              <br />

              <div className="panel panel-default container">
                <div className="panel-body">
                  <h3 className="panel-heading-text">{I18n.t("transactions")}</h3>

                  <Tabs tabs={this.tabs()} />
                  {/* <ul className="nav nav-tabs">
                    <li role="presentation" className={this.state.transactions_active_tab === "current_charges" ? "active" : null}>
                      <a className="nav-link" href="#current_charges" onClick={this.onChangeActiveTab.bind(null, "current_charges")}>{I18n.t("current_charges")}</a>
                    </li>
                    <li role="presentation" className={this.state.transactions_active_tab === "reversed_charges" ? "active" : null}>
                      <a className="nav-link" href="#reversed_charges" onClick={this.onChangeActiveTab.bind(null, "reversed_charges")}>{I18n.t("voided_charges")}</a>
                    </li>
                    <li role="presentation" className={this.state.transactions_active_tab === "payments" ? "active" : null}>
                      <a className="nav-link" href="#payments" onClick={this.onChangeActiveTab.bind(null, "payments")}>{I18n.t("payments")}</a>
                    </li>
                  </ul> */}
                  <br />

                  {this.state.transactions_active_tab === 'payments' ? <DataTable endpoint={this.props.payment_logs_path} time_format={this.props.time_format} date_format={this.props.date_format} read_only={this.props.read_only} tab_data_table={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
                  {this.state.transactions_active_tab === 'current_charges' ? <DataTable endpoint={this.props.folio_items_path} time_format={this.props.time_format} date_format={this.props.date_format} read_only={this.props.read_only} tab_data_table={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} reservation_segment={this.props.reservation_segment} folio_id={this.props.folio_id} /> : null}
                  {this.state.transactions_active_tab === 'reversed_charges' ? <DataTable endpoint={this.props.reversal_folio_items_path} time_format={this.props.time_format} date_format={this.props.date_format} read_only={this.props.read_only} tab_data_table={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} reservation_segment={this.props.reservation_segment} folio_id={this.props.folio_id} /> : null}

                </div>
              </div>

            </div>
          </div>

        :
        null
        }
        {
          !this.props.edit
          ?
            <div className="row">

              <div className="col-sm-6 form-group">
                <label>{I18n.t('folio_name')}</label>
                {
                  self.props.read_only
                    ?
                    <div>{self.props.name}</div>
                    :
                    <div>
                      <input name="name" value={this.props.name ? this.props.name : ""} onChange={self.props.onChange} className="form-control" />
                    </div>
                }
              </div>
            </div>
            :
            null
        }
      </div>
    );
  };

  tabs() {

    return (
      [
        {
          tabName: I18n.t('current_charges'),
          targetName: 'current_charges',
          classes: this.state.transactions_active_tab === 'current_charges' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('reversed_charges'),
          targetName: 'reversed_charges',
          classes: this.state.transactions_active_tab === 'reversed_charges' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('payments'),
          targetName: 'payments',
          classes: this.state.transactions_active_tab === 'payments' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };

  renderSummaryTableHead() {
    return(
      <thead className="thead">
        <tr className="active">
          <th scope="col">{I18n.t("total_charges")}</th>
          <th scope="col">{I18n.t("total_authorized")}</th>
          <th scope="col">{I18n.t("total_paid")}</th>
          <th scope="col">{I18n.t('balance')}</th>
        </tr>
      </thead>
    )
  }

  renderSummaryTableBody() {
    return (
      <tbody>
        <tr>
          <td>{this.formatCurrency(this.props.summary.total)}</td>
          <td>{this.formatCurrency(this.props.summary.total_authorized)}</td>
          <td>{this.formatCurrency(this.props.summary.total_paid)}</td>
          <td>{this.formatCurrency(this.props.summary.balance)}</td>
        </tr>
      </tbody>
    )
  }

  onChangeActiveTab(tab) {
    this.setState({
      transactions_active_tab: tab,
    });
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }
}

export default FolioBuilderWorkspace
